import { API } from '~apis/axios/instance';

export const createCardBillingMemo = ({
  companyId,
  itemId,
  content,
}: {
  companyId: string;
  itemId: number;
  content: string;
}) => {
  return API.post(
    `/api/v2/companies/${companyId}/labelling/card-billing-item-labels/${itemId}/memo`,
    {
      data: { content },
    },
  );
};

export const updateCardBillingMemo = ({
  companyId,
  transactionId,
  memoId,
  content,
}: {
  companyId: string;
  transactionId: number;
  memoId: number;
  content: string;
}) => {
  return API.put(
    `/api/v2/companies/${companyId}/labelling/card-billing-item-labels/${transactionId}/memo/${memoId}`,
    { data: { content } },
  );
};

export const upsertCardApprovalMemo = ({
  companyId,
  approvalId,
  content,
}: {
  companyId: string;
  approvalId: number;
  content?: string;
}) => {
  return API.post(`/api/v3/companies/${companyId}/corporate-cards/approvals/${approvalId}/memos`, {
    data: { content },
  });
};

export const upsertCardPurchaseMemo = ({
  companyId,
  purchaseId,
  content,
}: {
  companyId: string;
  purchaseId: number;
  content?: string;
}) => {
  return API.post(`/api/v3/companies/${companyId}/corporate-cards/purchases/${purchaseId}/memos`, {
    data: { content },
  });
};

export const upsertCardTransactionMemo = ({
  companyId,
  unifiedCardTransactionId,
  content,
}: {
  companyId: string;
  unifiedCardTransactionId: number;
  content?: string;
}) => {
  return API.post(
    `/api/v3/companies/${companyId}/unified-card-transaction/${unifiedCardTransactionId}/memos`,
    {
      data: { content },
    },
  );
};
